const showToast = (message, type = 'info', duration = 5000) => {
  const existingToast = document.getElementById('impower-toast');
  if (existingToast) {
    existingToast.remove();
  }

  const toast = document.createElement('div');
  toast.id = 'impower-toast';
  toast.style.position = 'fixed';
  toast.style.bottom = '20px';
  toast.style.right = '20px';
  toast.style.zIndex = '9999';
  toast.style.padding = '12px 24px';
  toast.style.borderRadius = '4px';
  toast.style.fontSize = '14px';
  toast.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
  toast.style.transition = 'opacity 0.3s ease-in-out';
  toast.style.display = 'flex';
  toast.style.alignItems = 'center';
  toast.style.justifyContent = 'space-between';
  toast.style.minWidth = '300px';
  toast.style.maxWidth = '400px';

  switch (type) {
    case 'success':
      toast.style.backgroundColor = '#52c41a';
      toast.style.color = '#fff';
      break;
    case 'error':
      toast.style.backgroundColor = '#ff4d4f';
      toast.style.color = '#fff';
      break;
    case 'warning':
      toast.style.backgroundColor = '#faad14';
      toast.style.color = '#fff';
      break;
    default:
      toast.style.backgroundColor = '#1890ff';
      toast.style.color = '#fff';
  }

  toast.textContent = message;

  const closeButton = document.createElement('span');
  closeButton.textContent = '×';
  closeButton.style.marginLeft = '16px';
  closeButton.style.cursor = 'pointer';
  closeButton.style.fontSize = '18px';
  closeButton.onclick = () => {
    document.body.removeChild(toast);
  };
  toast.appendChild(closeButton);

  document.body.appendChild(toast);

  setTimeout(() => {
    if (document.body.contains(toast)) {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (document.body.contains(toast)) {
          document.body.removeChild(toast);
        }
      }, 300);
    }
  }, duration);
};



